import React, { useEffect, useState } from 'react';

import { defaultInviteApiClient } from '../../clients';
import { TurnOnInviteLink } from './TurnOnInviteLink';
import { CopyInviteLink } from './CopyInviteLink';
import { useAnalytics } from '../../analytics';
import { ShareableLinkAnalytics } from './ShareableLinkAnalytics';

type ShareableLinkComponentProps = {
	inviteLink?: string;
	cloudId?: string;
	orgId?: string;
	onCloseTurnOnInviteLinkModal?: () => void;
	turnOnInviteLinkModalDismissed?: boolean;
};

export const ShareableLinkComponent = ({
	inviteLink,
	cloudId,
	orgId,
	onCloseTurnOnInviteLinkModal,
	turnOnInviteLinkModalDismissed,
}: ShareableLinkComponentProps) => {
	const [isInviteLinkCopied, setInviteLinkCopied] = useState(false);
	const [activeInviteLink, setActiveInviteLink] = useState(inviteLink);
	const [shouldShowTurnOnInvite, setShouldShowTurnOnInvite] = useState(
		!activeInviteLink && !turnOnInviteLinkModalDismissed,
	);
	const analytics = useAnalytics(ShareableLinkAnalytics);
	useEffect(() => {
		setActiveInviteLink(inviteLink);
	}, [inviteLink]);

	const handleCopyLink = () => {
		activeInviteLink &&
			navigator.clipboard.writeText(activeInviteLink).then(() => {
				setInviteLinkCopied(true);
				setTimeout(() => setInviteLinkCopied(false), 2000);
			});
		analytics.copyInviteLinkButtonClicked();
	};

	const handleAllowLink = async () => {
		try {
			const resourceId = `ari:cloud:confluence::site/${cloudId}`;
			const response = await defaultInviteApiClient.enableInviteLink(resourceId);
			if (typeof response === 'object' && response !== null && 'url' in response) {
				setShouldShowTurnOnInvite(false);
				setActiveInviteLink(response.url as string);
			}
			analytics.enableInviteLinkToggleClicked();
		} catch (err) {}
	};

	const handleCloseTurnOnInviteLink = () => {
		onCloseTurnOnInviteLinkModal?.();
		analytics.enableInviteLinkCloseButtonClicked();
		setShouldShowTurnOnInvite(false);
	};

	return (
		<>
			{shouldShowTurnOnInvite && (
				<TurnOnInviteLink
					handleAllowLink={handleAllowLink}
					handleCloseTurnOnInviteLink={handleCloseTurnOnInviteLink}
					orgId={orgId}
				/>
			)}
			{activeInviteLink && (
				<CopyInviteLink
					handleCopyLink={handleCopyLink}
					activeInviteLink={activeInviteLink}
					isInviteLinkCopied={isInviteLinkCopied}
				/>
			)}
		</>
	);
};
